export default "__VITE_ASSET__DuOrWKiJ__"